import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChatMessageDto } from 'src/app/data/models/dto/chat-message.dto';
import { ChatTypeEnum } from 'src/app/data/models/enum/chat-type.enum';
import { isToday } from 'src/app/data/utils/date.utils';
import { UserUtil } from 'src/app/data/utils/user.utils';

@Component({
  selector: 'app-chat-item',
  templateUrl: './chat-item.component.html',
  styleUrls: ['./chat-item.component.scss'],
})
export class ChatItemComponent {
  @Input() selected?: boolean;
  @Output() selectEvent = new EventEmitter<ChatMessageDto>();

  @Output() chatChange = new EventEmitter<ChatMessageDto>();

  chatTypeRoomMessage = ChatTypeEnum.ROOM_MESSAGE;
  chatTypeUserMessage = ChatTypeEnum.USER_MESSAGE;

  mouseOn = false;
  openMenu = false;

  constructor(private readonly userUtil: UserUtil) {}

  private _chat!: ChatMessageDto;

  public get chat(): ChatMessageDto {
    return this._chat;
  }

  @Input()
  public set chat(value: ChatMessageDto) {
    this._chat = value;
  }

  get idUser(): string {
    return this.userUtil.getUser().id;
  }

  isToday(date: Date): boolean {
    return isToday(date);
  }

  onClick() {
    this.chat.message.numMessagesUnread = 0;
    this.chat.message.unread = false;
    this.selectEvent.emit(this.chat);
  }

  touchLongPress() {
    this.mouseOn = true;
  }

  onTouchOutside() {
    this.mouseOn = false;
  }

  onChatChange(chat: ChatMessageDto) {
    this.chatChange.emit(chat);
  }
}
